import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { StyledCheckbox } from '../StyledCheckbox';
import { StyledText } from './styles';
export const OptionCheckbox = React.forwardRef(({ checked, children, className, disabled, hover = true, name, onChange, type, value, ...rest }, ref) => {
    return (_jsxs(StyledCheckbox.Label, { className, checked, disabled, children: [_jsx(StyledCheckbox.Input, { ref: ref, checked, name, onChange, type, value, disabled, ...rest }), _jsx(StyledCheckbox.Checkbox, { checked, disabled, hover }), _jsx(StyledText, { checked, disabled, children: children })] }));
});
//# sourceMappingURL=index.js.map